module.exports = __webpack_public_path__ + "img/zone4.9fe1c4e8.png";